module.exports = __webpack_public_path__ + "img/新闻 banner.5d59196e.jpg";